import type { SystemFitMode } from '@/components/dataquality/personViewMemory'
import { SYSTEM_FIT_MODES } from '@/components/dataquality/personViewMemory'

const MIN = 0.4
const MAX = 3
const STEP = 0.1
const DEFAULT_ZOOM = 1

interface ZoomSliderProps {
  value: number
  onChange: (value: number) => void
  label: string
  max?: number
}

export function SystemFitBar({
  value,
  onChange,
}: {
  value: SystemFitMode
  onChange: (mode: SystemFitMode) => void
}) {
  return (
    <div className="flex flex-wrap justify-end gap-1">
      {SYSTEM_FIT_MODES.map((mode) => (
        <button
          key={mode.id}
          type="button"
          aria-pressed={value === mode.id}
          onClick={() => onChange(mode.id)}
          className={`px-1.5 py-0.5 text-[11px] rounded border ${
            value === mode.id
              ? 'bg-gray-900 text-white border-gray-900'
              : 'bg-white text-gray-600 border-gray-300 hover:bg-gray-50'
          }`}
        >
          {mode.label}
        </button>
      ))}
    </div>
  )
}

export function ZoomSlider({ value, onChange, label, max = MAX }: ZoomSliderProps) {
  return (
    <div className="flex items-center gap-1.5 min-w-0">
      <input
        type="range"
        min={MIN}
        max={max}
        step={STEP}
        value={value}
        onChange={(e) => onChange(Number(e.target.value))}
        className="w-24 accent-blue-600"
        aria-label={label}
      />
      <span className="text-xs tabular-nums text-gray-500 w-9">{Math.round(value * 100)}%</span>
      <button
        type="button"
        onClick={() => onChange(DEFAULT_ZOOM)}
        disabled={value === DEFAULT_ZOOM}
        className="text-xs font-medium text-blue-700 hover:underline disabled:text-gray-400 disabled:no-underline"
        aria-label={`${label} zurücksetzen`}
      >
        Reset
      </button>
    </div>
  )
}
